import React from "react";

export const UiSplitImages = (props) => {
    return (
        <>
            <div className="sb-split-images">
                {props.images.map((image, index) => (
                    <img src={image} key={index} />
                ))}
            </div>
        </>
    );
};
